import { createFileRoute } from '@tanstack/react-router'
import { Header } from '@/components/Header'
import { Footer } from '@/components/Footer'
import { ProseLink } from '@/features/company-pages/components/ReadingProse'
import { StatusBody } from '@/features/company-pages/components/StatusBody'
import { PageHero } from '@/shared/components/marketing/PageHero'
import { generateLinks, generateMetaTags, routeSEO } from '@/lib/seo'

export const Route = createFileRoute('/status')({
  head: () => ({
    meta: generateMetaTags(routeSEO['/status']),
    links: generateLinks(routeSEO['/status']),
  }),
  component: StatusPage,
})

function StatusPage() {
  return (
    <div className="relative flex min-h-screen flex-col overflow-x-clip bg-[var(--color-bg-primary)]">
      <Header />

      <main className="flex-1">
        <PageHero
          eyebrow="Status"
          title="System status"
          lede={
            <>
              This page is updated manually. For live, per-model availability
              over the last 24 hours, see the{' '}
              <ProseLink to="/models">Models page</ProseLink>.
            </>
          }
        />
        <StatusBody />
      </main>

      <Footer />
    </div>
  )
}
